import SelectColTable from '@/components/SelectColTable.vue';
import FooterControl from '@/components/FooterControl.vue';
import { pageSizes, drugType } from '@/config/constant';

export default {
  name: 'home',
  components: { SelectColTable, FooterControl },
  data() {
    return {
      query: {
        stocktakingId: this.$route.query.id || '',
        drugType: -1,
        drugName: '',
        customType: '',
        emptyShow: 0,
      }, // 查询筛选参数
      remark: '', // 备注
      time: new Date(),
      pageSizes, // 分页数值
      drugType, // 药品分类列表
      stocktaking: [], // 未盘点列表
      total: 0, // 总数据条数
      pageSize: 20, // 每页数据条数
      currentPage4: 1, // 页码 从1开始
      isLoading: false,
      id: this.$route.query.id || '',
      rowList: [
        {
          name: '厂家',
          value: 'manufacturer',
          minWidth: '140',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '上次盘点时间',
          value: 'stocktakingTime',
          minWidth: '130',
          isSortable: true,
          disabled: false,
          checked: true,
        },
        {
          name: '货架码',
          value: 'shelfCode',
          minWidth: '88',
          isSortable: true,
          disabled: false,
          checked: true,
        },
        {
          name: '批号',
          value: 'drugBatchNo',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '有效期',
          value: 'validityDate',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '进货价',
          value: 'purchasePrice',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '零售价',
          value: 'prescriptionPrice',
          minWidth: '',
          isSortable: false,
          disabled: false,
          checked: true,
        },
      ],
      selectTableOptions: [
        {
          name: '日期',
          value: 'dates',
          disabled: true,
          checked: true,
        },
        {
          name: '日期',
          value: 'datess',
          checked: true,
        },
      ],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      },
    };
  },
  mounted() {
    this.getTableData(1);
  },
  methods: {
    // 完成盘点
    complete() {
      this.$api.drugControl.updateStocktaking({
        id: this.query.stocktakingId,
        status: 0, // 提交
        ...this.query,
      }).then((res) => {
        console.log(res);
        this.goback();
      });
    },
    goback() {
      this.$router.go(-1);
    },
    getTableCol(e) {
      this.rowList = e;
    },
    isShowEmptyStock(e) {
      if (e === this.query.emptyShow) {
        this.query.emptyShow = '0';
      }
    },
    getRowClass({ row }) {
      // 即没有子元素时，添加row-expand-cover类,隐藏展开icon
      if (row.stocktakingDetailBatch && row.stocktakingDetailBatch.length < 2) {
        return 'row-expand-cover';
      }
      return '';
    },
    // 获取盘点列表信息
    getTableData(type) {
      this.$api.drugControl.getStocktaking({
        id: this.id,
      }).then((res) => {
        console.log(res);
        this.time = res.time || new Date();
        this.remark = res.remark || '';
        this.alStocktaking(type);
      });
    },
    // 已盘点列表信息
    alStocktaking(type) {
      if (type === 1) {
        this.currentPage = 1;
      }
      this.$api.drugControl.alStocktaking({
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res);
        this.stocktaking = res.stocktakingDetail;
        this.total = res.totalSize;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getTableData();
    },
    // 导出盘点单
    exportCheckList() {
      if (this.stocktaking.length < 1 && this.noStocktaking.length < 1) {
        this.$alert('没有盘点单信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.$api.drugControl.stocktakingExport({
          stocktakingId: this.query.stocktakingId,
        });
      }
    },
    // 自定义分类检索
    querySearchCustomType(queryString, cb) {
      this.$api.drugControl.customType({
        customType: this.query.customType,
      }).then((res) => {
        res.typeList = res.typeList.map(item => ({ value: item }));
        cb(res.typeList);
      });
    },
    // 选择下拉框自定义分类
    handleSelectCustomType(item) {
      this.query.customType = item.value;
      this.getTableData(1);
    },
    getNum(real, book) {
      let plNum = [];
      let realNum = 0;
      let bookNum = 0;
      let units = '';
      let dis = 0; // 商
      let num = 0;
      let remainder = 0; // 余数
      real.forEach((item) => {
        realNum += Number(item.num) * Number(item.ratio);
      });
      book.forEach((item) => {
        bookNum += Number(item.num) * Number(item.ratio);
      });
      num = Number(realNum) - Number(bookNum);
      if (num < 0) {
        units = '-';
      } else if (num > 0) {
        units = '+';
      }
      num = Math.abs(num);
      book.forEach((item, index) => {
        if (index === 0) {
          dis = parseInt(num / (item.ratio), 10);
          remainder = num % (item.ratio);
        } else {
          dis = parseInt(remainder / (item.ratio), 10);
          remainder %= item.ratio;
        }
        plNum += `${dis}${item.unit}`;
      });
      return `${units}${plNum}`;
    },
  },
};
